/**
 *
 * @param deg
 * @returns {number}
 * @constructor
 */
function Deg2Rad(deg) {
    return deg * Math.PI / 180;
}

/**
 *
 * @param lat1
 * @param lon1
 * @param lat2
 * @param lon2
 * @returns {number}
 * @constructor
 */
function PythagorasEquirectangular(lat1, lon1, lat2, lon2) {
    lat1 = Deg2Rad(lat1);
    lat2 = Deg2Rad(lat2);
    lon1 = Deg2Rad(lon1);
    lon2 = Deg2Rad(lon2);
    var R = 6371; // km
    var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
    var y = (lat2 - lat1);
    var d = Math.sqrt(x * x + y * y) * R;
    return d;
}

/**
 *
 * @param latitude
 * @param longitude
 * @param locations
 * @param amountOfResults
 * @returns {*}
 * @constructor
 */
function ClosestLocations(latitude, longitude, locations, amountOfResults) {

    var closest;
    var mindif = 99999;
    var closestLocations = [];

    for (resultCount = 0; resultCount < amountOfResults; ++resultCount) {

        for (index = 0; index < locations.length; ++index) {

            if (locations[index]) {

                var dif = PythagorasEquirectangular(latitude, longitude, locations[index].latitude, locations[index].longitude);
                if (dif < mindif) {
                    closest = index;
                    mindif = dif;
                }

                if (index === (locations.length - 1)) {
                    mindif = 99999;
                    closestLocations.push(locations[closest]);
                    locations.splice(closest, 1);
                }

            }

        }

    }

    return closestLocations;
}

window.ClosestLocations = ClosestLocations;
